// /src/routes/Routes.js
import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

// Page Components
import LoginPage from '../pages/LoginPage';
import HomePage from '../pages/HomePage';
import Dashboard from '../pages/Dashboard';
import VerifyOTP from '../pages/VerifyOTP';
import BookAppointment from '../pages/BookAppointment';
import ThankYouPage from '../pages/ThankYouPage';
import ErrorPage from '../pages/ErrorPage';
import DentistRegistration from '../pages/DentistRegistration';
import PrivateRoute from '../components/PrivateRoute';

import { Box, Flex } from '@chakra-ui/react';

// Routes Configuration
const RoutesConfig = () => (
    <Flex maxW="100%" m={0} p={0} mx="auto">
        <Box width="100%">
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/register" element={<DentistRegistration />} />
                {/* Redirect /login without UUID to error page */}
                <Route path="/login" element={<Navigate to="/error?message=invalid-access" replace />} />
                <Route path="/verify" element={<VerifyOTP />} />
                <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                <Route path="/book-appointment" element={<PrivateRoute><BookAppointment /></PrivateRoute>} />
                <Route path="/thank-you" element={<PrivateRoute><ThankYouPage /></PrivateRoute>} />
                {/* Error route MUST come before /:uuid to avoid being caught by the catch-all */}
                <Route path="/error" element={<ErrorPage />} />
                {/* Catch-all route for UUID/friendly names - MUST be last */}
                <Route path="/:uuid" element={<LoginPage />} />
            </Routes>
        </Box>
    </Flex>
);

export default RoutesConfig;